export const dataWhyELSS = [
  {
    icon: 'https://assets1.cleartax-cdn.com/clearsave-frontend/images/1557211545_goal.png',
    title: 'Lowest Lock-in of 3 Years',
  },
  {
    icon: 'https://assets1.cleartax-cdn.com/clearsave-frontend/images/1557211553_handout.png',
    title: '2x higher interest rates than FD/PPF',
  },
  {
    icon: 'https://assets1.cleartax-cdn.com/clearsave-frontend/images/1557211561_money-coins.png',
    title: 'Option to invest Monthly (SIP)',
  },
  {
    icon: 'https://assets1.cleartax-cdn.com/clearsave-frontend/images/1557211568_payment.png',
    title: 'Invest as low as ₹500',
  },
];

export const ELSSWithCleartax = [
  {
    icon: 'http://cleartax-media.s3.amazonaws.com/clearsave-frontend/images/1558416705_easy-to-invest.png',
    title: 'Easy to Invest',
    subTitle: 'Invest in Hand-picked best performing Mutual funds',
  },
  {
    icon: 'https://assets1.cleartax-cdn.com/clearsave-frontend/images/1558416715_easy-tracking.png',
    title: 'Easy to track',
    subTitle: 'Track / monitor your investments 24/7',
  },
  {
    icon: 'https://assets1.cleartax-cdn.com/clearsave-frontend/images/1558416723_easy-withdrawal.png',
    title: 'Easy to withdraw',
    subTitle: 'Withdraw anytime in 1-click with no paperwork needed',
  },
  {
    icon: 'https://assets1.cleartax-cdn.com/clearsave-frontend/images/1558416739_paperless.png',
    title: 'Paperless',
    subTitle: 'Sign up, complete your KYC and invest online in 10 minutes.',
  },
  {
    icon: 'https://assets1.cleartax-cdn.com/clearsave-frontend/images/1558416692_bank-graded-security.png',
    title: 'Bank graded security',
    subTitle:
      'Data security is our priority and all you investments are completely secure',
  },
  {
    icon: 'https://assets1.cleartax-cdn.com/clearsave-frontend/images/1558416730_inv-proof-hr.png',
    title: 'Investment proof for HR',
    subTitle: 'Get your 80C investment proof instantly and submit to HR.',
  },
];

export const ELSSFAQs = {
  heading: 'FAQs (Frequently asked Questions)',
  content:
    'As a tax-paying citizen, the Section-80c of the Indian Tax Act allows you some breather –',
  subContent: ' a deduction of up to 150,000 from your total annual income.',
  qaSet: [
    {
      question: 'What are ELSS funds?',
      answer: {
        preText:
          'ELSS funds are tax saving mutual funds, in which majority of the funds are invested in equity schemes.',
      },
    },
    {
      question: 'What is the lock-in period?',
      answer: {
        preText: 'ELSS has a lock-in period of 3 years.',
      },
    },
    {
      question:
        'What is the maximum tax benefit that can be availed by investing in ELSS every year?',
      answer: {
        preText:
          'Under section 80C, one can avail tax benefit upto Rs 46,800 by investing upto Rs 1.5 lakhs per year in tax-saving schemes such as ELSS. You can also invest more than Rs 1.5 lakhs in ELSS.',
      },
    },
    {
      question: 'Why to invest in ELSS?',
      answer: {
        preText:
          'ELSS has benefits over other conventional tax saving instruments like FDs, NPS, etc. It has the lowest lock in period and the returns are higher than the other tax-saving schemes.',
      },
    },
    {
      question: 'Who should invest in ELSS?',
      answer: {
        preText:
          'Anyone who wishes to reduce income tax by investing in 80C tax-saving schemes. ELSS is an equity investment. Hence, it is more suitable for people who are open to risk and stay invested for a long time to reap the benefits.',
      },
    },
    {
      question: 'Is there any tax associated with ELSS?',
      answer: {
        preText:
          'As the lock in period of ELSS funds are 3 years, the gains are treated as long-term gains and they are taxed at 10% for gains over 1 lakh rupees.',
      },
    },
    {
      question: 'What are equity funds?',
      answer: {
        preText:
          'Equity funds are schemes which concentrate their investments in shares of companies of different market capitalization',
      },
    },
    {
      question: 'Should I choose SIP or lump sum?',
      answer: {
        preText:
          'An SIP allows you to invest a fixed sum regularly in mutual fund(s) of your choice. A lump sum is when you invest on-time in bulk in mutual fund(s). SIP comes with few advantages:',
        points: [
          'It allows you to invest small amount every month without the stress of paying in bulk',
          'Investing all through the year averages the cost of investing – you don’t end up paying too much per unit',
          'Gives you financial discipline',
        ],
      },
    },
    {
      question: 'How to invest in an SIP on ClearTax?',
      answer: {
        preText: 'The process is very simple on ClearTax.',
        points: [
          'Step 1: Select the fund(s) and the amount you want to invest every month',
          'Step 2: Provide your details and make payment for the first month',
          'Step 3: Activate SIP payments for the rest of the months via one of the 3 methods we offer',
        ],
      },
    },
    {
      question: 'Why invest through ClearTax?',
      answer: {
        preText:
          'ClearTax is super easy and simple to use. We do the homework for you and offer the best-performing mutual funds chosen by experts. It takes less than 5 minutes to invest on ClearTax.',
      },
    },
    {
      question: 'How to invest in Mutual funds at ClearTax?',
      answer: {
        preText: 'The process is very simple on ClearTax.',
        points: [
          'Step 1: Select the fund(s) and the amount you want to invest every month',
          'Step 2: Provide your details ',
          'Step 3: Make payment and you are done',
        ],
      },
    },
    {
      question: 'Is KYC necessary for ClearTax?',
      answer: {
        preText:
          'KYC is necessary for all fund houses. If you are investing through ClearTax, you need to do your KYC just once. The same KYC will be used for all further investments.',
      },
    },
    {
      question: 'How to do KYC on ClearTax?',
      answer: {
        preText:
          'KYC verification through ClearTax is a very simple process. You can verify by: ',
        points: [
          'Using OTP sent to your Aadhaar-registered mobile number OR',
          'By uploading photos/scans of the required documents',
        ],
      },
    },
  ],
};

export const RentFaqs = {
  heading: 'Frequently asked questions about HRA',
  qaSet: [
    {
      question: 'Why do I need to get a receipt from my landlord?',
      answer: {
        preText:
          'Your employer needs a proof of rent payment to allow exemption on HRA. The employer is required to collect proofs from you before allowing any exemptions &amp; deductions. This is your employer’s responsibility as per the income tax act.',
      },
    },
    {
      question: 'Do I need a lease agreement with my landlord?',
      answer: {
        preText:
          'Yes, you need a lease agreement with your landlord. This agreement must have details of the accommodation on lease, period of lease and rent. This document may also have to be submitted to your employer.',
      },
    },
    {
      question: 'Why does my company ask me to submit rent receipt proofs?',
      answer: {
        preText:
          'To allow you exemption on HRA, it is mandatory for the employer to collect proof of rent payment. The employer will give you exemption on HRA based on these rent receipts. Your final tax liability will be calculated accordingly. Your TDS shall be adjusted so you don’t have to pay tax on HRA.',
      },
    },
    {
      question: 'Do I need a receipt for every month?',
      answer: {
        preText: 'Usually, employers need receipts for 3 months or so.',
      },
    },
    {
      question: 'Do I need the PAN number of my landlord?',
      answer: {
        preText:
          'If the annual rent paid by you is more than Rs 1,00,000, it is mandatory to obtain PAN of the landlord and report it to the employer to claim HRA exemption.In case the landlord does not have a PAN, you can ask for a declaration to this effect from the landlord with name and address of the landlord. And keep it safely in your records.',
      },
    },
    {
      question: 'Do I need a scanned copy of my landlord’s PAN card?',
      answer: {
        preText:
          'No, you don’t need to keep a scanned copy of your landlord’s PAN.',
      },
    },
    {
      question:
        'I was not able to claim HRA from my company. Can I claim it myself?',
      answer: {
        preText:
          'Yes, HRA exemption can be directly claimed in your income tax return. You can use this calculator to find out the exempt portion of HRA. This exempt amount has to be reduced from your total taxable salary. The net amount is shown as your ‘income from salary’ in your income tax return.In case you claim HRA exemption directly in your tax return, you must maintain rent receipts and lease agreement safely in your records; in case the assessing officer asks for them later.',
      },
    },
    {
      question:
        'I have changed jobs this year. Should I share my old rent receipts with the new company?',
      answer: {
        preText:
          "If your current employer is allowing you HRA exemption from previous job's income, you may be required to submit your old rent receipts. Do remember to disclose your salary from your previous employment to your current employer in Form 12B.",
      },
    },
    {
      question:
        'My landlord is refusing to give me a rent receipt. What can I do?',
      answer: {
        preText:
          'In case your landlord does not provide you a rent receipt you may not be able to claim HRA exemption. Do agree with your landlord regarding rent receipts before taking the accommodation on rent.',
      },
    },
    {
      question:
        'I was in a rental apartment for part of the year. Can I claim HRA?',
      answer: {
        preText:
          'Yes, you can claim HRA exemption for the months you were paying rent.',
      },
    },
    {
      question:
        'Is there a deadline for submitting proofs (rent receipts) to my company?',
      answer: {
        preText:
          'Since employers need to deduct and deposit TDS timely, they usually provide a deadline by which all tax proofs must be submitted. By submitting your rent receipts and other proofs timely, you can make sure no extra TDS is deducted on your income.However, do not worry if you miss this deadline. You can claim HRA exemption directly in your income tax return.',
      },
    },
    {
      question: 'Do I need hard-copy of rent receipts or is a soft copy OK?',
      answer: {
        preText:
          'Check with your employer about the format in which you have to submit.',
      },
    },
    {
      question: 'What are rent receipts?',
      answer: {
        preText:
          'Rent receipts are official documents provided by landlords to tenants upon receiving rent payment. They serve as proof of the payment and specify the amount paid, rental period covered, and details of both the landlord and the tenant. These receipts are crucial for claiming tax benefits like House Rent Allowance (HRA).',
      },
    },
    {
      question: 'What is a Rent Receipt Generator?',
      answer: {
        preText:
          'A Rent Receipt Generator is an online tool that helps you create an accurate rent receipt quickly and easily. All you will have to do is enter the required information like tenant and landlord details, rental period, payment amount, etc.',
      },
    },
    {
      question: 'Why should I use a Rent Receipt Generator?',
      answer: {
        preText:
          'Rent receipts are official documents provided by landlords to tenants upon receiving rent payment. They serve as proof of the payment and specify the amount paid, rental period covered, and details of both the landlord and the tenant. These receipts are crucial for claiming tax benefits like House Rent Allowance (HRA).',
      },
    },
    {
      question: 'What are rent receipts?',
      answer: {
        preText: `Using a Rent Receipt Generator offers several benefits:
          Convenience: Saves time and effort compared to manually creating a receipt.
          Accuracy: Reduces the risk of errors in date, amounts, or other details.
          Professional: Creates a neat and organized receipt that looks official.`,
      },
    },
    {
      question: 'How do I download or print the receipt?',
      answer: {
        preText:
          'Fill in the required details, and you will see the option to print the receipt in PDF Format. Get the receipt signed by your landlord and submit it to your HR.',
      },
    },
    {
      question: 'Is a generated receipt legally valid?',
      answer: {
        preText:
          'Yes, generated rent receipts are legally valid if they contain all the required information and are signed by both the tenant and landlord.',
      },
    },
    {
      question: 'How to fill the rent receipt?',
      answer: {
        preText: `Visit Cleartax rent receipt generator(https://cleartax.in/save/rent)
            Enter the monthly rent amount, house address and click on ‘Proceed’
            Enter your name, email address, Landlord’s name, Landlord’s PAN (if the total rent exceeds Rs 1 lakh) and rent period 
            Click on ‘Generate Receipts’, verify the details and ‘Print Receipts’
            Affix the revenue stamp if cash payment > Rs 5,000 and your landlord’s signature
            Submit the receipt copy to your HR`,
      },
    },
    {
      question: 'Is rent receipt mandatory for HRA exemption?',
      answer: {
        preText:
          'Yes, rent receipts are mandatory for claiming HRA exemption. You need to submit copies of receipts for the entire financial year to your employer',
      },
    },
    {
      question: 'Is revenue stamp mandatory on the rent receipt?',
      answer: {
        preText:
          'Revene stamp is required on a rent receipt only if the rent payment through cash mode is more than Rs 5,000. No revenue stamp is required if the rent payment is done through cheque, bank transfer, or by other digital means.',
      },
    },
    {
      question: 'How to fill rent receipt with revenue stamp?',
      answer: {
        preText:
          'Visit Cleartax rent receipt generator(https://cleartax.in/save/rent) and add all the required details. Print the receipts and affix the revenue stamp if cash payment > Rs 5,000.',
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./constants/elss.ts